<template>
  <div
    class=""
    ref="dialog"
    id="dialog"
    tabindex="-1"
    role="dialog"
    aria-labelledby="Modal"
    style="display: block"
  >
    <div class="modal-dialog modal-xl" role="document">
      <form @submit.prevent="callCashIn">
        <div class="modal-content">
          <div class="modal-header">
            <div>
              <h4 class="modal-title">Cash In</h4>
              <p>Hier können Sie einen Verkauf am Automaten simulieren</p>
            </div>
          </div>
          <div class="modal-body form">

            <div class="form-group">
              <label for="amount">Amount</label>
              <div class="input-group">
                <input
                  v-model="amount"
                  type="text"
                  id="amount"
                  class="form-control"
                  placeholder="0.00"
                  aria-describedby="amount"
                />
              </div>
            </div>

            <div class="form-group">
              <label for="productId">Product Id</label>
              <div class="input-group">
                <input
                  v-model="productId"
                  type="text"
                  id="productId"
                  class="form-control"
                  placeholder="0"
                  aria-describedby="productId"
                />
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button
              type="submit"
              class="btn btn-outline-dark"
              data-dismiss="modal"
            >Cash In
            </button>
          </div>
        </div>
      </form>
    </div>
    <div v-if="messageTopic" class="alert alert-success" role="alert">
      <p>{{messageTopic}}</p>
      <p>{{message}}</p>
    </div>
    <div v-if="errorMessage" class="alert alert-danger" role="alert">
      <p>{{errorMessage}}</p>
    </div>
  </div>

</template>

<script>
  import axios from "axios";
  import { TT_URL } from "@/common/constants";

  export default {
  name: "cashIn",
  props: {
    tibTag: {type: String, required: true}
  },
  data: function () {
    return {
      amount: null,
      productId: null,
      messageTopic: null,
      message:null,
      errorMessage:null
    };
  },
  methods: {
    callCashIn() {
      let self = this;
      this.messageTopic = null;
      this.message = null;

      console.info("cashIn " + this.productId + " " + (this.amount * 100.0) + " " + this.tibTag);

      axios
        .post(TT_URL + "/api/rest/tibtix/pay/cashIn", {
          tibTag: this.tibTag,
          productId: this.productId,
          amount: this.amount * 100,
        })
        .then(response => this.showResult(response.data))
        .catch(error => this.showError(error));
    },
    showResult(trx) {
      this.errorMessage = null;
      this.messageTopic = trx.messageTopic;
      this.message = trx.message;
    },
    showError(error) {
      this.errorMessage = error.message;
      this.messageTopic = null;
      this.message = null;
    }
  }
};
</script>
